import { FC } from 'react'

import { Actions, Body, ColumnAction, FilterButton } from './styles'

export const MobileFilterPanelSkeleton: FC = () => {
  return (
    <Body>
      <Actions>
        <FilterButton />
        <div>
          <ColumnAction />
          <ColumnAction />
        </div>
      </Actions>
    </Body>
  )
}
